import { type Theme } from '../../../theme';
import { type ButtonStyles } from '../button.types';

export const getPrimaryButton = (theme: Theme): ButtonStyles => ({
  base: {
    color: theme.button.primary.label,
    backgroundColor: theme.button.primary.default,
    boxShadow: `0 1px 0 0 rgba(0, 0, 0, 0.06), 0 1px 2px 0 rgba(0, 0, 0, 0.05), 0 4px 6px 0 rgba(255, 255, 255, 0.15) inset`,
    border: `1px solid ${theme.button.primary.border}`,

    '&:hover': {
      backgroundColor: theme.button.primary.hover,
      boxShadow: `0 1px 0 0 rgba(0, 0, 0, 0.06), 0 1px 2px 0 rgba(0, 0, 0, 0.05), 0 4px 6px 0 rgba(255, 255, 255, 0.15) inset`,
    },
    '&:active, &:focus:not(:focus-visible)': {
      backgroundColor: theme.button.primary.pressed,
      outline: 'none',
      boxShadow:
        '0 4px 26px 0 rgba(255, 255, 255, 0.35) inset, 0 1px 0 0 rgba(0, 0, 0, 0.06), 0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    },
    '&:focus': {
      outline: `2.5px solid ${theme.button.focused.default}`,
      outlineOffset: 4,
      backgroundColor:
        'linear-gradient(180deg, rgba(255, 255, 255, 0.10) 0%, rgba(255, 255, 255, 0.00) 100%)',
      backgroundBlendMode: 'lighten',
    },
  },
  active: {},
  isLoading: {},
  disabled: {
    backgroundColor: theme.button.primary.disabled,
    color: theme.button.disabled.label,
    boxShadow: 'none',
    cursor: 'not-allowed',

    '&:hover': {
      backgroundColor: 'none',
    },
    '&:active, &:focus:not(:focus-visible)': {
      backgroundColor: theme.button.primary.disabled,
      outline: 'none',
    },
    svg: {
      color: theme.button.ghost.disabled,
    },
  },
});
